<template>
   <div class="channels-list" id="channel_selections">
      <check
         v-for="(value, key) in options"
         :key="key"
         :value="value.recid"
         :text="value.name"
         :isChecked="isChecked(value.recid)"
         :green="true"
         v-on:input="onCheck"
      > 
      </check>
   </div>
</template>

<script>
import Vue from "vue";
import BaseCheckInfoBox from '@/global/BaseCheckInfoBox';

export default {
   extends: BaseCheckInfoBox,

   data() {
      return {
      }
   },

   props: {
      selections: Array
   },

   created() {
      for (let channel of this.selections) {
         Vue.set(this.options, channel.recid, {isChecked: false, name: channel.c_name, recid: channel.recid});
      }
   },

   methods: {
      onCheck(target) {
         if (target.checked) {
            this.initialSelected.push(target.value);
         } else {
            if (this.initialSelected.length == 1) {
               //send event
               this.$emit('lastCheck');
            } else {
               var index = this.initialSelected.indexOf(target.value);
               if (index > -1) {
                  this.initialSelected.splice(index, 1);
               }
            }
         }
      },

      isChecked(recid) {
         return this.initialSelected.includes(recid)
      }
   },

}
</script>

